import { Modal } from 'react-bootstrap';
import {
    ApiSchemaJobDataById,
    CloseJobModal,
    MiscellaneousBillsDetails,
    MiscellaneousDocumentAmounts,
    MiscellaneousDocumentDescriptions, MiscellaneousDocumentFileKeys,
    MiscellaneousDocumentFileNames,
    MiscellaneousInfo
} from '../../models';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
    useFunctionalityBookingAgentBillsDetails,
    useFunctionalityBookingCloseJob,
    useFunctionalityBookingCloseJobInfoDetails
} from "../../pages/hooks";
import { JobMiscellaneousDescription } from "./modalBodies/jobCloseModal/JobMiscellaneousDescription";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { AppConstants, FileBucketURL } from "../../configs";
import { useAppSelector, VRIAppStateType} from "../../core";
import { useFunctionalityInputChecker } from '../../pages/hooks/functionalityInputChecker';

type Props = {
    show: boolean,
    handleShow: (value: boolean) => void,
    selectedJob?: ApiSchemaJobDataById,
    actualStartTime?: any,
    actualEndTime?: any,
    startDate?: any,
    endDate?: any,
    mileage?: any,
    jobCloseNote?: any,
    miscellaneousAmount?: any,
    bookingId?: any,
    bookingAgentBills?: any,
    showSerialNoEditCloseModal?: string
    setSweetBillChangeProp?: any
    setSweetPageReloadProp?: any
    operatorUserId?: string
}

export function ModalCloseViewJob(props: Props): JSX.Element {
    const { bookingAgentBills, bookingId, showSerialNoEditCloseModal, operatorUserId } = props;
    const [cancelJob, setCancelJob] = useState(false);


    const { handleSubmit } = useForm<CloseJobModal>();
    const [vosFile, setVosFile] = useState<any>({});
    const [miscellaneousData, setMiscellaneousData] = useState<MiscellaneousBillsDetails[]>([]);
    const [miscellaneousDataLength, setMiscellaneousDataLength] = useState<number>(0);
    const [miscellaneousIdCount, setMiscellaneousIdCount] = useState(1);

    const [actualStartDate, setActualStartDate] = useState(props.startDate);
    const [actualStartTime, setActualStartTime] = useState(props.actualStartTime);
    const [actualEndDate, setActualEndDate] = useState(props.endDate);
    const [actualEndTime, setActualEndTime] = useState(props.actualEndTime);
    const [onSelectStartTime, setOnSelectStartTime] = useState(false);
    const [onSelectEndTime, setOnSelectEndTime] = useState(false);
    const [closeJobInfoDetails, setCloseJobInfoDetails] = useState<any>({});

    const [mileage, setMileage] = useState<Number>(closeJobInfoDetails?.mileage??0);

    const [closeJobNote, setCloseJobNote] = useState('');
    const [miscellaneousDocumentDescriptions, setMiscellaneousDocumentDescriptions] = useState<MiscellaneousDocumentDescriptions[]>([]);
    const [miscellaneousDocumentAmounts, setMiscellaneousDocumentAmounts] = useState<MiscellaneousDocumentAmounts[]>([]);
    const [miscellaneousDocumentFiles, setMiscellaneousDocumentFiles] = useState<MiscellaneousDocumentFileKeys[]>([]);
    const [miscellaneousDocumentFilesName, setMiscellaneousDocumentFilesName] = useState<MiscellaneousDocumentFileNames[]>([]);
    const [error, setError] = useState<string>('');
    const [selectedVosFilePath, setSelectedVosFilePath] = useState('');
    const [previewVosFile, setPreviewVosFile] = useState('');

    const data = useAppSelector(
        (state: VRIAppStateType) => ({
            userRole: state.auth.profile?.userRole
        }),
    );

    const { onCloseJob } = useFunctionalityBookingCloseJob();
    const { handleLimitDecimalPlaces } = useFunctionalityInputChecker()


    const { onCompanyCloseJobInfoDetails } = useFunctionalityBookingCloseJobInfoDetails({
        bookingId: bookingId ?? '',
        operatorUserId: (bookingAgentBills?.operatorUserId || operatorUserId) ?? ''
    });

    const [editCloseModalStartDateTime, setEditCloseModalStartDateTime] = useState<string>('');
    const [editCloseModalEndDateTime, setEditCloseModalEndDateTime] = useState<string>('');

    const getCurrentDate = () => {
        let today: any = new Date();
        let dd: any = today.getDate();
        let mm: any = today.getMonth() + 1;
        const yyyy: any = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const currentDate = (new Date(getCurrentDate() ?? "" + 3).toISOString()).substring(0, 10);
    const currentTime = moment(new Date()).local().format('HH:mm');

    const getMaxSerialNoOfMiscellaneousBills = (miscellaneousBills: any) => {
        let miscellaneousSerialNo = miscellaneousBills?.map((miscellaneousBill: MiscellaneousBillsDetails) => miscellaneousBill?.miscellaneousBillSerialNo ?? 0);

        if (!miscellaneousSerialNo[0]) {
            miscellaneousSerialNo.push(miscellaneousBills?.length + 1);
        }

        return Math.max(...miscellaneousSerialNo);
    }

    useEffect(() => {
        onCompanyCloseJobInfoDetails()
            ?.then((res) => {
                setCloseJobInfoDetails(res?.data);
                setEditCloseModalStartDateTime(res?.data?.startDate);
                setEditCloseModalEndDateTime(res?.data?.endDate);
                setMiscellaneousData(res?.data?.miscellaneousBills);
                setMiscellaneousDataLength(res?.data?.miscellaneousBills?.length);
                setCloseJobNote(res?.data?.jobCloseNote);
                setMiscellaneousIdCount(getMaxSerialNoOfMiscellaneousBills(res?.data?.miscellaneousBills) ?? 1);
                if (props.setSweetBillChangeProp)
                    props?.setSweetBillChangeProp((prev: number) => prev + 1)
            }
            )
    }, []);

    useEffect(() => {
        const miscellaneousDescriptions: MiscellaneousDocumentDescriptions[] = miscellaneousData?.map(
            (data: MiscellaneousBillsDetails) =>
                ({ documentId: data?.miscellaneousBillSerialNo, documentDescription: data?.description })
        );

        const miscellaneousAmounts: MiscellaneousDocumentAmounts[] = miscellaneousData?.map(
            (data: MiscellaneousBillsDetails) =>
                ({ documentId: data?.miscellaneousBillSerialNo, documentAmount: data?.amount })
        );
        const miscellaneousDocuments: MiscellaneousDocumentFileKeys[] = miscellaneousData?.map(
            (data: MiscellaneousBillsDetails) =>
                ({ documentId: data?.miscellaneousBillSerialNo, documentFileKey: data?.fileKey })
        );

        setMiscellaneousDocumentDescriptions(miscellaneousDescriptions ?? []);
        setMiscellaneousDocumentAmounts(miscellaneousAmounts ?? []);
        setMiscellaneousDocumentFiles(miscellaneousDocuments ?? []);
    }, [miscellaneousDataLength]);

    useEffect(() => {
        setMileage(closeJobInfoDetails?.mileage)
    }, [closeJobInfoDetails])
    

    const onButtonClickHandler = () => {
        const input = document.getElementById('file');
        if (input) {
            input.click();
        }
    }

    const onCloseJobModalHandler = () => {
        props.handleShow(false);
        setCancelJob(false);
    }

    const modalHideHandler = () => {
        props.handleShow(false);
    }

    const handleMileage = (event: any) => {
        setMileage(Number(event.target.value));
    }

    const handleCloseJobNote = (event: any) => {
        setCloseJobNote(event.target.value);
    }

    const handleStartDate = (event: any) => {
        setActualStartDate(event.target.value);
    }

    const handleStartTime = (event: any) => {
        setOnSelectStartTime(true);
        setActualStartTime(event.target.value);
    }

    const handleEndDate = (event: any) => {
        setActualEndDate(event.target.value);
    }

    const handleEndTime = (event: any) => {
        setOnSelectEndTime(true);
        setActualEndTime(event.target.value);
    }

    const getTime = (time: string) => {
        return moment(time).local().format('HH:mm');
    }

    const onCloseJobHandler = (form: any) => {
        const convertedActualStartTime = onSelectStartTime ? actualStartTime.substring(0, 8) :
            actualStartTime ? getTime(actualStartTime).substring(0, 8) : editCloseModalStartDateTime ?
                editStartTime(editCloseModalStartDateTime) : currentTime;

        let startDate = actualStartDate ? actualStartDate : editCloseModalStartDateTime ? editStartDate(editCloseModalStartDateTime) : currentDate;
        let startTime = convertedActualStartTime ? convertedActualStartTime : currentTime;

        let todayStartTime = new Date(startDate + ' ' + startTime);
        const todayStartTimeUTC = todayStartTime.toUTCString();

        const convertedActualEndTime = onSelectEndTime ? actualEndTime.substring(0, 8) :
            actualEndTime ? getTime(actualEndTime).substring(0, 8) : editCloseModalEndDateTime ?
                editEndTime(editCloseModalEndDateTime) : currentTime;

        let endDate = actualEndDate ? actualEndDate : editCloseModalEndDateTime ? editEndDate(editCloseModalEndDateTime) : currentDate;
        let endTime = convertedActualEndTime ? convertedActualEndTime : currentTime;

        let todayEndTime = new Date(endDate + ' ' + endTime);
        const todayEndTimeUTC = todayEndTime.toUTCString();

        form = {
            ...form,
            actualStart: todayStartTimeUTC,
            actualEnd: todayEndTimeUTC,
            mileage: mileage,
            vosFormFile: vosFile,
            closeJobNote: closeJobNote,
            documentDescriptions: miscellaneousDocumentDescriptions,
            documentAmounts: miscellaneousDocumentAmounts,
            documentFiles: miscellaneousDocumentFiles
        }

        const body = new FormData();
        body.append('actualStart', form.actualStart);
        body.append('actualEnd', form.actualEnd);
        body.append('mileage', form.mileage);
        body.append('vosFormFile', form.vosFormFile);
        if (closeJobNote) {
            body.append('closeJobNote', form.closeJobNote);
        }

        if (data.userRole === AppConstants.UserRoles.Admin) {
            body.append('operatorUserId', bookingAgentBills?.operatorUserId ?? '');
        }

        for (var i = 0; i < miscellaneousData.length; i++) {
            body.append('documentDescriptions', miscellaneousDocumentDescriptions[i]?.documentDescription ?? '');
            body.append('documentAmounts', miscellaneousDocumentAmounts[i]?.documentAmount);
            body.append('documentFiles', miscellaneousDocumentFiles[i]?.documentFileKey ?? '');

            if (miscellaneousDocumentAmounts[i]?.documentAmount === '') {
                setError('Please fill all Amount sections of miscellaneous documents !');
                return;
            }
        }

        setError('');

        const bookingId = props.selectedJob?.id ? props.selectedJob?.id : props.bookingId ? props.bookingId : '';
        onCloseJob(body, bookingId)?.then(() => {
            if (props.setSweetBillChangeProp)
                props?.setSweetBillChangeProp((prev: number) => prev + 1)
            if (props.setSweetPageReloadProp)
                props?.setSweetPageReloadProp((prev: number) => prev + 1)

            modalHideHandler();
        })
    }

    const handleVoSFile = (event: any) => {
        setVosFile(event.target.files[0]);
        setSelectedVosFilePath(event.target.files[0].name);
        const previewFileUrl = URL.createObjectURL(event.target.files[0])
        setPreviewVosFile(previewFileUrl)
    }

    const handleAddMiscellaneousInfo = () => {
        const miscellaneousList = [...miscellaneousData, {
            miscellaneousBillSerialNo: miscellaneousIdCount,
            description: '',
            amount: '',
            fileKey: ''
        }];

        setMiscellaneousData(miscellaneousList);
        setMiscellaneousIdCount((prev: number) => prev + 1);

        const miscDesc: MiscellaneousDocumentDescriptions = {
            documentId: miscellaneousIdCount,
            documentDescription: ''
        };

        setMiscellaneousDocumentDescriptions([...miscellaneousDocumentDescriptions, miscDesc]);

        const miscAmount: MiscellaneousDocumentAmounts = {
            documentId: miscellaneousIdCount,
            documentAmount: ''
        };

        setMiscellaneousDocumentAmounts([...miscellaneousDocumentAmounts, miscAmount]);

        const miscFileKey: MiscellaneousDocumentFileKeys = {
            documentId: miscellaneousIdCount,
            documentFileKey: ''
        };

        setMiscellaneousDocumentFiles([...miscellaneousDocumentFiles, miscFileKey]);
    }

    const handleRemoveMiscellaneousInfo = (id: any) => {
        const filteredMiscellaneousData: MiscellaneousBillsDetails[] = miscellaneousData?.filter((data: MiscellaneousBillsDetails) => data?.miscellaneousBillSerialNo !== id);
        setMiscellaneousData(filteredMiscellaneousData);

        const filteredMiscellaneousDescriptions: MiscellaneousDocumentDescriptions[] = miscellaneousDocumentDescriptions?.filter((data: MiscellaneousDocumentDescriptions) => data?.documentId !== id);
        setMiscellaneousDocumentDescriptions(filteredMiscellaneousDescriptions);

        const filteredMiscellaneousAmounts: MiscellaneousDocumentAmounts[] = miscellaneousDocumentAmounts?.filter((data: MiscellaneousDocumentAmounts) => data?.documentId !== id);
        setMiscellaneousDocumentAmounts(filteredMiscellaneousAmounts);

        const filteredMiscellaneousFileKeys: MiscellaneousDocumentFileKeys[] = miscellaneousDocumentFiles?.filter((data: MiscellaneousDocumentFileKeys) => data?.documentId !== id);
        setMiscellaneousDocumentFiles(filteredMiscellaneousFileKeys);
    }

    const handleMiscellaneousDescription = (event: any, id: any) => {
        const filteredMiscellaneousDocumentDescriptions: MiscellaneousDocumentDescriptions[] = miscellaneousDocumentDescriptions?.filter((data: MiscellaneousDocumentDescriptions) => data?.documentId !== id);
        const newMiscellaneousDescriptionDocument: MiscellaneousDocumentDescriptions = {
            documentId: id,
            documentDescription: event.target.value
        };
        setMiscellaneousDocumentDescriptions([...filteredMiscellaneousDocumentDescriptions, newMiscellaneousDescriptionDocument]);
        miscellaneousData[id - 1].description = event.target.value;
    }

    const handleMiscellaneousAmount = (event: any, id: any) => {
        const filteredMiscellaneousDocumentAmounts: MiscellaneousDocumentAmounts[] = miscellaneousDocumentAmounts?.filter((data: MiscellaneousDocumentAmounts) => data?.documentId !== id);
        const newMiscellaneousDescriptionAmount: MiscellaneousDocumentAmounts = {
            documentId: id,
            documentAmount: Number(event.target.value)
        };
        setMiscellaneousDocumentAmounts([...filteredMiscellaneousDocumentAmounts, newMiscellaneousDescriptionAmount]);
        miscellaneousData[id - 1].amount = Number(event.target.value);
    }

    const handleMiscellaneousFile = (event: any, id: any) => {
        const newFileName: MiscellaneousDocumentFileNames = {
            documentId: id,
            documentFileName: event.target.files[0].name
        };

        const filteredFilesName: MiscellaneousDocumentFileNames[] = miscellaneousDocumentFilesName?.filter((data: MiscellaneousDocumentFileNames) => data?.documentId !== id);
        const prevAndNewFilesName = [...filteredFilesName, newFileName];
        setMiscellaneousDocumentFilesName(prevAndNewFilesName);

        const filteredMiscellaneousDocumentFileKeys: MiscellaneousDocumentFileKeys[] = miscellaneousDocumentFiles?.filter((data: MiscellaneousDocumentFileKeys) => data?.documentId !== id);
        const newMiscellaneousDescriptionFileKey: MiscellaneousDocumentFileKeys = {
            documentId: id,
            documentFileKey: event.target.files[0]
        };

        setMiscellaneousDocumentFiles([...filteredMiscellaneousDocumentFileKeys, newMiscellaneousDescriptionFileKey]);
        miscellaneousData[id - 1].fileKey = event.target.files[0];
    }

    const editStartDate = (startDate: string) => {
        const index = startDate.indexOf('T');
        const date = startDate.substring(0, index);
        return date;
    }

    const editEndDate = (endDate: string) => {
        const index = endDate.indexOf('T');
        const date = endDate.substring(0, index);
        return date;
    }

    const editStartTime = (startTime: string) => {
        // const index = startTime.indexOf('T');
        // const time = startTime.substring(index+1);
        const time = moment(startTime).local().format('HH:mm');
        return time;
    }

    const editEndTime = (endTime: string) => {
        // const index = endTime.indexOf('T');
        // const time = endTime.substring(index+1);
        const time = moment(endTime).local().format('HH:mm');
        return time;
    }

    const getStartDate = () => {
        return actualStartDate ? actualStartDate : editCloseModalStartDateTime ?
            editStartDate(editCloseModalStartDateTime) : currentDate;
    }

    const getStartTime = () => {
        return actualStartTime ? getTime(actualStartTime) : editCloseModalStartDateTime ?
            editStartTime(editCloseModalStartDateTime) : currentTime;
    }

    const getEndDate = () => {
        return actualEndDate ? actualEndDate : editCloseModalEndDateTime ?
            editEndDate(editCloseModalEndDateTime) : currentDate;
    }

    const getEndTime = () => {
        return actualEndTime ? getTime(actualEndTime) : editCloseModalEndDateTime ?
            editEndTime(editCloseModalEndDateTime) : currentTime;
    }

    return (
        <>
            <Modal
                show={props.show}
                onHide={() => {
                    props.handleShow(false)
                    setCancelJob(false)
                }}
                size="lg"
                centered
            >
                <form onSubmit={handleSubmit(onCloseJobHandler)} noValidate>
                    <div>
                                {/*@ts-ignore */}
        <Modal.Header closeButton>
                            <Modal.Title className="test-modal">{
                                props.selectedJob?.serialNo ? 'Close Job #'.concat(props.selectedJob?.serialNo ?? '-') :
                                    'Close Job #'.concat(showSerialNoEditCloseModal ?? '-')
                            }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <div className="container-fluid px-0">

                                <div className="row  mx-0">

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-7 pl-lg-0">
                                        <div className="form-group row">
                                            <div className="col-6 px-0">
                                                <label htmlFor="job-close-start-date" className="required col">Start date </label>
                                                <div className="col">
                                                    <input className="form-control" type="date"
                                                        key={editCloseModalStartDateTime}
                                                        defaultValue={getStartDate()}
                                                        id="job-close-start-date"
                                                        name="job-close-start-date" onChange={handleStartDate} />
                                                </div>
                                            </div>
                                            <div className="col-6 px-0">
                                                <label htmlFor="job-close-start-time" className="required col">Start time </label>
                                                <div className="col">
                                                    <input className="form-control" type="time"
                                                        key={editCloseModalStartDateTime}
                                                        defaultValue={getStartTime()}
                                                        id="job-close-start-time"
                                                        name="job-close-start-time" onChange={handleStartTime} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-6 px-0">
                                                <label htmlFor="job-close-end-date" className="required col">End date</label>
                                                <div className="col">
                                                    <input className="form-control" type="date"
                                                        key={editCloseModalEndDateTime}
                                                        defaultValue={getEndDate()}
                                                        id="job-close-end-date"
                                                        name="job-close-end-date" onChange={handleEndDate} />
                                                </div>
                                            </div>
                                            <div className="col-6 px-0">
                                                <label htmlFor="job-close-end-time" className="required col">End time</label>
                                                <div className="col">
                                                    <input className="form-control" type="time"
                                                        key={editCloseModalEndDateTime}
                                                        defaultValue={getEndTime()}
                                                        id="job-close-end-time"
                                                        name="job-close-end-time" onChange={handleEndTime} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-12 col-sm-12 col-md-6 px-0">
                                                <label htmlFor="job-close-mileage" className="col">Mileage</label>
                                                <div className="col">
                                                    <input className="form-control" type="number" min="0.0" defaultValue={props.mileage ?? closeJobInfoDetails?.mileage} onBlur={handleMileage} onInput={(event) => handleLimitDecimalPlaces(event, 2)} />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 px-0">
                                                <div className="col">
                                                    <label htmlFor="" className="">VoS</label>
                                                    {
                                                        (closeJobInfoDetails?.vosFormFileKey || previewVosFile) && <div className="btn svg-color px-3 py-0"
                                                            onClick={(event: any) => {
                                                                event.preventDefault();
                                                                if (previewVosFile) {
                                                                    window.open(previewVosFile, '_blank');
                                                                } else {
                                                                    window.open(`${FileBucketURL?.Root}${closeJobInfoDetails?.vosFormFileKey}`, "_blank");
                                                                }
                                                            }} >
                                                            <svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_119_17)">
                                                                    <path d="M341.333 128C346.991 128 352.418 130.248 356.418 134.248C360.419 138.249 362.667 143.675 362.667 149.333C362.667 154.991 360.419 160.418 356.418 164.418C352.418 168.419 346.991 170.667 341.333 170.667H170.667C165.009 170.667 159.583 168.419 155.582 164.418C151.581 160.418 149.333 154.991 149.333 149.333C149.333 143.675 151.581 138.249 155.582 134.248C159.583 130.248 165.009 128 170.667 128H341.333ZM505.749 505.749C501.749 509.749 496.324 511.995 490.667 511.995C485.01 511.995 479.585 509.749 475.584 505.749L424.235 454.4C409.028 464.106 391.374 469.285 373.333 469.333C354.346 469.333 335.786 463.703 319.999 453.154C304.212 442.606 291.907 427.613 284.641 410.071C277.375 392.529 275.474 373.227 279.178 354.605C282.882 335.982 292.025 318.877 305.451 305.451C318.877 292.025 335.983 282.882 354.605 279.178C373.227 275.474 392.529 277.375 410.071 284.641C427.613 291.907 442.606 304.211 453.155 319.999C463.703 335.786 469.333 354.346 469.333 373.333C469.285 391.374 464.106 409.028 454.4 424.235L505.749 475.584C509.749 479.585 511.996 485.01 511.996 490.667C511.996 496.324 509.749 501.749 505.749 505.749ZM373.333 426.667C383.882 426.667 394.193 423.539 402.964 417.678C411.734 411.818 418.57 403.489 422.607 393.743C426.644 383.998 427.7 373.274 425.642 362.929C423.584 352.583 418.505 343.08 411.046 335.621C403.587 328.162 394.084 323.083 383.738 321.025C373.393 318.967 362.669 320.023 352.924 324.06C343.178 328.096 334.849 334.932 328.988 343.703C323.128 352.474 320 362.785 320 373.333C320 387.478 325.619 401.044 335.621 411.046C345.623 421.048 359.189 426.667 373.333 426.667ZM277.333 469.333H149.333C132.36 469.333 116.081 462.591 104.079 450.588C92.0763 438.586 85.3334 422.307 85.3334 405.333V106.667C85.3334 89.6928 92.0763 73.4142 104.079 61.4118C116.081 49.4095 132.36 42.6667 149.333 42.6667H405.333C410.991 42.6667 416.418 44.9143 420.418 48.9151C424.419 52.9158 426.667 58.342 426.667 64V234.667C426.667 240.325 428.914 245.751 432.915 249.752C436.916 253.752 442.342 256 448 256C453.658 256 459.084 253.752 463.085 249.752C467.086 245.751 469.333 240.325 469.333 234.667V64C469.333 47.0261 462.591 30.7475 450.588 18.7452C438.586 6.74284 422.307 0 405.333 0L149.333 0C121.054 0.0338743 93.9427 11.2828 73.9461 31.2794C53.9496 51.2759 42.7006 78.3873 42.6667 106.667V405.333C42.7006 433.613 53.9496 460.724 73.9461 480.721C93.9427 500.717 121.054 511.966 149.333 512H277.333C282.991 512 288.418 509.752 292.418 505.752C296.419 501.751 298.667 496.325 298.667 490.667C298.667 485.009 296.419 479.582 292.418 475.582C288.418 471.581 282.991 469.333 277.333 469.333Z" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_119_17">
                                                                        <rect width="512" height="512" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="input-group col" >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="upload"
                                                        aria-label="Upload file"
                                                        name="button-upload-file"
                                                        aria-describedby="button-upload-file"
                                                        readOnly
                                                        value={selectedVosFilePath}

                                                    />
                                                    <input
                                                        className="d-none"
                                                        type="file"
                                                        id="file"
                                                        name='certificate'
                                                        onChange={handleVoSFile}
                                                    />
                                                    <div className="input-group-append">
                                                        <button className="btn btn-primary" type="button" id="button-upload-file" onClick={(e) => {
                                                            e.preventDefault()
                                                            onButtonClickHandler()
                                                        }}>

                                                            <label className="mb-0" htmlFor="file">
                                                                <FontAwesomeIcon icon={faPaperclip} className="" />
                                                            </label>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                        <div className="form-group row">
                                            <div className="col-12 px-0">
                                                <label htmlFor="" className="col">Note</label>

                                                <div className="col">
                                                    <textarea className="form-control" defaultValue={props.jobCloseNote ?? closeJobInfoDetails?.jobCloseNote} onBlur={handleCloseJobNote} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="col-12 col-sm-12 col-md-12 col-lg-5 ">

                                        <div className="row  mb-3 mx-0  ml-auto ">

                                            <button className="btn btn-primary" type="button" onClick={handleAddMiscellaneousInfo}>Add Miscellaneous </button>
                                        </div>
                                        <div className="miscelleous-container">
                                            {
                                                miscellaneousData && <JobMiscellaneousDescription miscellaneousData={miscellaneousData}
                                                    handleRemoveMiscellaneousInfo={handleRemoveMiscellaneousInfo}
                                                    handleMiscellaneousDescription={handleMiscellaneousDescription}
                                                    handleMiscellaneousAmount={handleMiscellaneousAmount}
                                                    handleMiscellaneousFile={handleMiscellaneousFile}
                                                    miscellaneousDocumentFilesName={miscellaneousDocumentFilesName} />
                                            }
                                        </div>

                                        {
                                            error && <div className="row">
                                                <div className="">
                                                    <span className="text-danger">{error} </span>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                className="btn btn-link text-site text-uppercase"
                                onClick={onCloseJobModalHandler}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary text-uppercase login-from-submit-btn"
                                disabled={!(closeJobInfoDetails?.vosFormFileKey || previewVosFile)}
                            >
                                Submit
                            </button>
                            {/* <button type="submit" className="btn btn-primary text-uppercase login-from-submit-btn">submit</button>
                                <button type="button" className="btn btn-secondary text-uppercase" onClick={onCloseJobModalHandler}>Close</button> */}
                        </Modal.Footer>
                    </div>
                </form>
            </Modal>
        </>
    );
}